import { type ReactNode } from 'react';
import { Button } from '@/components/ui/button';

const BAR =
  'flex items-center justify-between gap-md border-t border-white/[0.06] pt-base';

type BarProps = {
  onConfirm: () => void;
  onCancel: () => void;
  pending: boolean;
};

function Confirm({
  onConfirm,
  onCancel,
  pending,
  label,
  variant,
}: BarProps & { label: string; variant: 'danger' | 'primary' }): ReactNode {
  return (
    <div className="flex gap-sm">
      <Button variant="ghost" size="sm" onClick={onCancel}>
        Cancelar
      </Button>
      <Button
        variant={variant}
        size="sm"
        onClick={onConfirm}
        disabled={pending}
      >
        {label}
      </Button>
    </div>
  );
}

export function ArchiveBar(p: BarProps): ReactNode {
  return (
    <div className={BAR}>
      <p className="text-xs text-text-secondary">
        ¿Archivar miembro? Sus leads, pagos y bonos se conservan.
      </p>
      <Confirm {...p} label="Archivar" variant="danger" />
    </div>
  );
}

export function RestoreBar(p: BarProps): ReactNode {
  return (
    <div className={BAR}>
      <p className="text-xs text-text-secondary">
        ¿Restaurar miembro? Volverá a estado activo.
      </p>
      <Confirm {...p} label="Restaurar" variant="primary" />
    </div>
  );
}

export function StreakResetBar(p: BarProps): ReactNode {
  return (
    <div className={BAR}>
      <p className="text-xs text-text-secondary">
        ¿Resetear streaks? Borra el historial de fails y strikes. Si estaba
        baneado por no cumplir objetivos, también lo desbanea. La engine empieza
        a contar desde hoy.
      </p>
      <Confirm {...p} label="Resetear" variant="danger" />
    </div>
  );
}
